/*
 * @Author: Q in
 * @Date: 2026-03-27 19:22:06
 * @LastEditors: Q in 
 * @LastEditTime: 2026-10-28 11:04:16
 * @FilePath: /new_kefu_pc/src/mixins/index-socket-chat.js
 * @Description: 客服端聊天全局共享状态与方法
 *
 * 使用方式：
 *   import globalMixin from '@/mixins/index-socket-chat.js';
 *   // 读取状态
 *   globalMixin.state.currentSession
 *   // 调用方法
 *   globalMixin.methods.generateMessageId()
 */
import Vue from 'vue';
import { playNotificationSound } from '@/utils/audio';
import { formatTime } from '@/utils/publicFn.js';

/** 消息类型 */
const MESSAGE_TYPES = {
	0: '富文本',
	1: '图片',
	2: '文件',
	3: '系统消息',
	4: '商品卡片',
	5: '订单卡片',
	6: '视频',
	7: '音频',
	8: '咨询卡片',
	9: '来源商品卡片 - PUBG',
    17: '来源商品卡片 - 三角洲租号',
	10: '@用户消息',
	11: '催一催',
	12: '撤回消息',
	13: '三角洲-商品卡片',
	14: '三角洲-订单卡片',
	15: '三角洲-撞车卡片',
    16: '三角洲-发布商品卡片',
};

// ─── 未读消息配置 ────────────────────────────────────────────────────────────
const UNREAD_MESSAGES_CONFIG = {
	UNREAD_MESSAGES_DELAY: 2000, // 未读消息间隔（2秒）
	UNREAD_MESSAGES_MESSAGE: { a: 'unread_messages', c: 'Message' }
};

// ─── 响应式全局状态（运行时动态数据）────────────────────────────────────────
export const globalState = Vue.observable({
	// ── WebSocket & DOM 引用 ──────────────────────────────────────────────
	/** 客户端 WebSocket 实例 */
	indexSocket: null,
	/** 客户端 WebSocket 连接状态 */
	wsConnected: false,
	// 是否拉黑
	isBlack: false,
	/** 未读消息定时器 */
	unreadMessagesTimer: null,
	/** 未读消息数量 */
	unreadMessagesCount: 0,
	/** 聊天区域实例 */
	chatMessagesRef: null,
	// 是否显示客服窗口
	showKefuButton: false,
	// 提示内容
	tipContent: '',
	// 是否显示提示
	tipVisible: false,
	// 提示定时器
	tipTimer: null,
	/** 当前登录的客服信息 */
	user_info: {},
	/** 快捷回复 */
	fast_reply: [],
	// 客服端平台选项
	platform_options: '',
	/** 会话列表 */
	session_list: {
		all: [],
		private: [],
		group: []
	},
	/** 当前会话 */
	activeSession: {},
	/** 消息列表 */
	pageParams: {
		page: 1,
		next_page: 'done'
	},
	session_messages: [],
	loadingMessages: false,
	unexpected_records: 0, // 用户发送消息记录数量 + 和客服发送消息记录数量

	// 详情商品展示
	automaticallyProductShow: false,
	// 详情商品信息
	automaticallyProductInfo: null,

	// ── 其他业务状态 ──────────────────────────────────────────────────────
	/** 表情列表 */
	emojiCategories: ['😀', '😂', '😍', '😘', '😢', '😭', '😔', '😞', '😡', '😠', '😤', '🤬', '😱', '😨', '😰', '😳', '😜', '😝', '😛', '😎', '🤔', '😕', '😶', '🤐', '🤗', '🥰', '💖', '❤️', '🥳', '🎉', '🎊', '🎶', '🤑', '💰', '💸', '🥺', '🙈', '🙉', '🙊'],
	/** 咨询商品 tabs */
	consultProductTabs: [
		{ id: 1, name: '我的浏览', icon: 'icon-lianjie' },
		{ id: 2, name: '我的收藏', icon: 'icon-shoucang' }
	],
	/** 咨询商品 tabs 当前选中项 */
	consultProductTabActive: 1,
	browseParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
	browse_list: [],
	// 收藏记录
	collectParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
	collect_list: [],

	/** 我的订单 tabs */
	orderTabs: [
		{ id: 1, name: '二手号', icon: 'icon-pintu' },
		{ id: 2, name: '卡密商品', icon: 'icon-a-SafetyProtection_yuechi_key_linear' },
		{ id: 3, name: '三角洲租赁', icon: 'icon-svg' },
		{ id: 4, name: '三角洲撞车', icon: 'icon-svg' },
		// { id: 2, name: '已售出', icon: 'icon-yishouchu' },
	],
	/** 我的订单 tabs 当前选中项 */
	orderTabActive: 1,
	// 二手号订单请求参数
	secondHandParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
	secondHandList: [],
	// 卡密商品订单请求参数
	carmiParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
	carmiList: [],
    // 三角洲租赁订单请求参数
    deltaRentalParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
	deltaRentalList: [],
    // 三角洲撞车订单请求参数
    deltaCrashParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
	deltaCrashList: [],

    myProductTabs: [
		{ id: 1, name: '寄售商品', icon: 'icon-kefu-shangpin-copy' },
		{ id: 2, name: '三角洲出租商品', icon: 'icon-svg' }
	],
    // 我的商品 tabs 当前选中项
    myProductTabActive: 1,
	// 我的商品请求参数
	productParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
	productList: [],
    // 三角洲出租商品请求参数
    sjzRentalParams: {
		loading: false,
		page: 1,
		page_size: 10,
		total: 0
	},
    // 三角洲出租商品列表
	sjzRentalList: []
});

// ─── 全局方法 ────────────────────────────────────────────────────────────────
export const globalMethods = {
	// 设置客服窗口显示状态
	setShowKefuButton(val) {
		globalState.showKefuButton = val;
	},

	/**
	 * 启动未读消息定时器
	 * 每 2 秒向服务端请求未读消息数量
	 */
	_startUnreadMessagesTimer() {
		const that = globalState;
		this._stopUnreadMessagesTimer();
		that.unreadMessagesTimer = setInterval(() => {
			if (that.indexSocket && that.indexSocket.connected) {
				that.indexSocket.send(UNREAD_MESSAGES_CONFIG.UNREAD_MESSAGES_MESSAGE);
			}
		}, UNREAD_MESSAGES_CONFIG.UNREAD_MESSAGES_DELAY);
	},

	/**
	 * 停止未读消息定时器
	 */
	_stopUnreadMessagesTimer() {
		const that = globalState;
		if (that.unreadMessagesTimer) {
			clearInterval(that.unreadMessagesTimer);
			that.unreadMessagesTimer = null;
		}
	},

	/**
	 * 未读消息数量回调
	 * @param {Object} data 服务端返回的未读消息数据
	 */
	unread_messages(data) {
		const that = globalState;
		const date = data.data || {};
		that.unreadMessagesCount = date.count || 0;
	},

	// 初始化
	initialize(data) {
		const date = data.data;
		console.log('initialize', date);
	},

	// 会话列表初始化
	session_list_initialize(data) {
		const that = globalState;
		const date = data.data;
		console.log('session_list_initialize', date);
		that.activeSession = date.session || {};

        that.session_list.all = date.session_list.all || [];
        that.session_list.private = date.session_list.private || [];
        that.session_list.group = date.session_list.group || [];

        // 发送【三角洲创建租赁订单】消息
        const rental_product_sn = localStorage.getItem('rental_product_sn');
        if (!rental_product_sn) return;
        that.indexSocket.send({
            c: 'SjzManager',
            a: 'sjzProductDetail',
            data: {
                sn: rental_product_sn,
            }
        });
	},

	// 服务端上线
	online(data) {
		const that = globalState;
		// console.log('客户端上线消息', data);
		if (that.activeSession.csr == data.user_id) {
			if (that.activeSession.session_type != 0) return;
			that.activeSession.csr_status = 3;
		}

		// 更新全部会话列表
        if (that.session_list.all && Array.isArray(that.session_list.all)) {
            that.session_list.all = that.session_list.all.map((item) => {
                if (item.session_type != 0) return item;
                if (item.csr == data.user_id) item.csr_status = 3;
                return item;
            });
        }

		// 更新私有会话列表
        if (that.session_list.private && Array.isArray(that.session_list.private)) {
            that.session_list.private = that.session_list.private.map((item) => {
                if (item.csr == data.user_id) item.csr_status = 3;
                return item;
            });
        }
	},

	// 服务端下线
	offline(data) {
		const that = globalState;
		// console.log('服务端下线消息', data);
		// 更新当前会话状态
		if (that.activeSession.csr == data.user_id) {
			if (that.activeSession.session_type != 0) return;
			that.activeSession.csr_status = 2;
		}

		// 更新全部会话列表
		that.session_list.all = that.session_list.all.map((item) => {
			if (item.session_type != 0) return item;
			if (item.csr == data.user_id) item.csr_status = 2;
			return item;
		});

		// 更新私有会话列表
		that.session_list.private = that.session_list.private.map((item) => {
			if (item.csr == data.user_id) item.csr_status = 2;
			return item;
		});
	},

	// 消息处理
	show_msg(data) {
		const that = globalState;
		if (data.code == 0) {
			this.$toast.show(data.msg);
		}
	},

	// 新消息处理
	async new_message(data) {
		const that = globalState;
		let date = data.data || {};
		// console.log('新消息:', date);
		// 播放提示音
		playNotificationSound();

		if (!that.showKefuButton) {
			if (that.tipTimer) {
				clearTimeout(that.tipTimer);
				that.tipTimer = null;
			}

			that.tipContent = date.last_message || '';
			that.tipVisible = true;
			// 2秒后隐藏提示
			that.tipTimer = setTimeout(() => {
				that.tipVisible = false;
				that.tipContent = '';
				that.tipTimer = null;
			}, 2000);
		}

		// 会话到顶部
		const moveSessionToTop = (list, item) => {
			const index = list.findIndex((session) => session.id === item.id);
			if (index != -1) {
				list.splice(index, 1);
				list.unshift(item);
			}
		};

		if (!that.activeSession.id) return;

		if (that.activeSession.id == date.session_id) {
			// 同一会话
			// 记录当前会话框 用户发送消息数量 + 和客服发送消息数量
            that.unexpected_records = that.unexpected_records + 1;

			// 更新会话列表
			const updateList = (list) =>
				list.map((item) =>
					item.id == date.id
						? {
								...item,
								message_type: date.message_type,
								last_message: date.last_message || '',
								last_time: date.last_time,
								last_timestamp: date.createtime,
								unread_msg_count: 0
						  }
						: item
				);

			// 插入新消息到会话框
			that.session_messages.push({
				avatar: date.avatar || '', // 头像
				name: date.name || '', // 发送者名称
				createtime: date.createtime || '', // 创建时间
				createtime_text: date.createtime_text || '', // 创建时间文本
				id: date.record_id || '', // 消息ID
				message: date.message || '', // 消息内容
				message_type: date.message_type || '', // 消息类型
				sender: date.sender || '', // 发送者标识
				sender_id: date.sender_id || '', // 发送者ID
				sender_identity: date.sender_identity || '',
				session_id: date.session_id || '', // 会话ID
				status: 1 || '' // 消息状态
			});
			// 发送请求
			that.indexSocket.send({
				c: 'Message',
				a: 'readMessage',
				data: {
					record_id: date.record_id,
					session_id: that.activeSession.id
				}
			});
			// 更新会话列表
			if (date.session_type == 0) {
				// 私聊：更新私聊、全部列表
				that.session_list.private = updateList(that.session_list.private);
				moveSessionToTop(
					that.session_list.private,
					that.session_list.private.find((item) => item.id == date.id)
				);
			} else {
				// 群聊：更新群聊列表、全部列表
				that.session_list.group = updateList(that.session_list.group);
				moveSessionToTop(
					that.session_list.group,
					that.session_list.group.find((item) => item.id == date.id)
				);
			}
			that.session_list.all = updateList(that.session_list.all);
			moveSessionToTop(
				that.session_list.all,
				that.session_list.all.find((item) => item.id == date.id)
			);
			// 智能滚动：只有当用户在底部时才滚动
			this.$nextTick(() => {
				if (that.chatMessagesRef) {
					// 计算是否在底部（允许100px的误差）
					let lastMsg;
					const messages = that.chatMessagesRef.querySelectorAll('.message-item, .message-system');
					lastMsg = messages.length > 0 ? messages[messages.length - 1] : null;

					const isAtBottom = that.chatMessagesRef.scrollTop + that.chatMessagesRef.clientHeight >= that.chatMessagesRef.scrollHeight - (lastMsg.clientHeight + 50);

					// 只有当用户在底部时才滚动
					if (isAtBottom) {
						that.chatMessagesRef.scrollTop = that.chatMessagesRef.scrollHeight;
						// console.log('自动滚动到底部');
					} else {
						// console.log('用户不在底部，不自动滚动');
					}
				}
			});
		} else {
			// 不是同一会话
			// 更新会话列表
			const updateList = (list) =>
				list.map((item) =>
					item.id == date.id
						? {
								...item,
								message_type: date.message_type,
								last_message: date.last_message || '',
								last_time: date.last_time,
								last_timestamp: date.createtime,
								unread_msg_count: date.unread_msg_count
						  }
						: item
				);
			if (date.session_type == 0) {
				// 私聊：更新私聊、全部列表
				that.session_list.private = updateList(that.session_list.private);
				moveSessionToTop(
					that.session_list.private,
					that.session_list.private.find((item) => item.id == date.session_id)
				);
			} else {
				// 群聊：更新群聊列表、全部列表
				that.session_list.group = updateList(that.session_list.group);
				moveSessionToTop(
					that.session_list.group,
					that.session_list.group.find((item) => item.id == date.session_id)
				);
			}
			that.session_list.all = updateList(that.session_list.all);
			moveSessionToTop(
				that.session_list.all,
				that.session_list.all.find((item) => item.id == date.session_id)
			);
		}
	},

	// 客服状态更新
	csr_change_status(data) {
		const that = globalState;
		const date = data.data;
		// console.log('csr_change_status', date);
		that.session_list.all = that.session_list.all.map((item) => (item.csr == date.csr ? { ...item, csr_status: date.csr_status } : item));
		that.session_list.private = that.session_list.private.map((item) => (item.csr == date.csr ? { ...item, csr_status: date.csr_status } : item));
		if (that.activeSession.csr == date.csr) {
			that.activeSession.csr_status = date.csr_status;
		}
	},

    // 创建订单群聊完成
    create_order_group(data) {
        const that = globalState;
        const date = data.data;
        console.log('创建订单群聊完成消息', date);
    },

    // 创建订单群聊完成 - 给所有群成员发送新群聊消息
    new_group_created(data) {
        const that = globalState;
        const date = data.data;
        console.log('创建新群聊完成消息1', date);
        that.session_list.all.unshift(date);
        that.session_list.group.unshift(date);
        localStorage.removeItem('order_no');
        // 选中当前会话
        // that.activeSession = date;
    },

	// 创建群聊完成
	create_group_done(data) {
		// {
		//     createtime: 1774528809
		//     csr_id: 3
		//     deletetime: null
		//     id: 351
		//     is_do_not_disturb: 0
		//     session_members: [
		//         { avatar: '', createtime: '', deletetime: '', id: '', member_id: '', member_identity: '', name: '', session_id: '' },
		//         { avatar: '', createtime: '', deletetime: '', id: '', member_id: '', member_identity: '', name: '', session_id: '' },
		//         { avatar: '', createtime: '', deletetime: '', id: '', member_id: '', member_identity: '', name: '', session_id: '' },
		//     ]
		//     session_name: ""
		//     session_type: 1
		//     user_id: 353
		// }
		const that = globalState;
		const date = data.data;
		// console.log('创建群聊完成消息', date);
		// 遍历当前全部会话列表，移除 item.id == date.id 的私聊会话，创建一个群聊会话
		that.session_list.all = that.session_list.all.filter((item) => item.id != date.id);
		that.session_list.all.push(date);
		that.session_list.group = that.session_list.group.filter((item) => item.id != date.id);
		that.session_list.group.push(date);
		// 从私聊中移除这个会话
		that.session_list.private.splice(
			that.session_list.private.findIndex((item) => item.id == that.activeSession.id),
			1
		);
		that.activeSession.session_type = date.session_type;
	},

	/**
	 * 转移会话完成回调
	 * @param {Object} data 转移会话完成数据
	 */
	transfer_done(data) {
		const that = globalState;
		const date = data.data;
		// console.log('转移会话完成消息', date);
		that.session_list.private.forEach((item) => {
			if (item.id == date.session_id) {
				item.name = date.nickname;
				item.avatar = date.avatar;
			}
		});
		that.session_list.all.forEach((item) => {
			if (item.id == date.session_id) {
				item.name = date.nickname;
				item.avatar = date.avatar;
			}
		});
	},

	/**
	 * 客户端聊天记录处理
	 * @param {Object} data 聊天记录数据
	 */
	chat_record(data) {
		const that = globalState;
		const date = data.data;
		// console.log('chat_record', date);

		// 是否是第一页加载
		const isFirstLoad = date.page == 1;

		// 加载更多时，先记录当前滚动高度，插入后用差值恢复位置
		const prevScrollHeight = that.chatMessagesRef ? that.chatMessagesRef.scrollHeight : 0;

		// 设置分页、新消息、撤回消息状态
		that.pageParams.page = date.page;
		that.pageParams.next_page = date.next_page;
		const newMessages = [...date.chat_record[0].data].reverse();
		newMessages.forEach((item) => (item.isrevoke = false));

		// 处理消息列表
		if (isFirstLoad) {
			that.session_messages = newMessages;
			that.unexpected_records = 0;
		} else {
			that.session_messages = [...newMessages, ...that.session_messages];
		}
		that.loadingMessages = false;

		this.$nextTick(() => {
			if (!that.chatMessagesRef) return;
			that.chatMessagesRef.scrollTop = isFirstLoad ? that.chatMessagesRef.scrollHeight : that.chatMessagesRef.scrollHeight - prevScrollHeight;
		});
	},

	/**
     * 构建本地消息插入聊天框
     * @param {Object} data 消息数据 message_type:
        0=富文本 1=图片 2=文件 3=系统消息 4=商品卡片
        5=订单卡片 6=视频 7=音频，8=咨询卡片 9=来源商品卡片
        10=@用户消息 11=催一催 12=撤回消息
        * @param {string} fun 插入方式：'append'（追加）或 'prepend'（前置）
        * @param {string} message_id 消息ID
        */
	buildRecord(data, fun = 'append', message_id = 'none') {
		const that = globalState;

		// 构建消息对象（所有类型结构相同）
		const message = {
			avatar: that.user_info.avatar || '', // 头像
			createtime: message_id || '', // 创建时间
			createtime_text: formatTime(message_id || '', 'YYYY-MM-DD HH:mm:ss'),
			id: message_id || '', // 消息ID
			message: data.message, // 消息内容
			message_type: data.message_type, // 消息类型
			name: that.user_info.nickname || '', // 发送者名称
			sender: 'me', // 发送者标识
			sender_id: that.user_info.id || '', // 发送者ID
			sender_identity: 1, // 发送者身份标识 0=客服,1=用户
			session_id: that.activeSession.id, // 会话ID
			isrevoke: false, // 是否撤回
			status: 0 // 消息状态 0未读 1已读
		};

		// 根据插入方式添加消息
		if (fun == 'append') {
			that.session_messages.push(message);
		}

		// 消息类型 → 会话列表展示文本映射
		const msgTextMap = {
			0: data.message, // 富文本
			1: '[图片]', // 图片
			2: '[文件]', // 文件
			3: data.message, // 系统消息：显示原文
			4: '[商品卡片]', // 商品卡片
			5: '[订单卡片]', // 订单卡片
			6: '[视频]', // 视频
			7: '[音频]', // 音频
			8: '[咨询卡片]', // 咨询卡片
			9: '[来源商品卡片 - PUBG]', // 来源商品卡片 - PUBG
            17: '[来源商品卡片 - 三角洲租号]', // 来源商品卡片 - 三角洲租号
			10: data.message, // @用户消息
			11: data.message, // 催一催
			12: '撤回消息', // 撤回消息
            13: '[三角洲-商品卡片]',
            14: '[三角洲-订单卡片]',
            15: '[三角洲-撞车卡片]',
            16: '[三角洲-发布商品卡片]',
		};

		// 同步更新会话列表中的最新消息和时间
		const updateList = (list) =>
			list.map((item) =>
				item.id == this.activeSession.id
					? {
							...item,
							message_type: data.message_type,
							last_message: msgTextMap[data.message_type] || '',
							last_time: formatTime(message_id, 'HH:mm'),
							last_timestamp: message_id
					  }
					: item
			);

		// 更新左侧消息列表
		if (that.activeSession.session_type == 0) {
			// 私聊：更新私聊、全部列表
			that.session_list.private = updateList(that.session_list.private);
		} else {
			// 群聊：更新群聊列表、全部列表
			that.session_list.group = updateList(that.session_list.group);
		}
		that.session_list.all = updateList(that.session_list.all);

		// 自动滚动到底部
		this.$nextTick(() => {
			const chatMessages = that.chatMessagesRef;
			if (!chatMessages) return;
			chatMessages.scrollTop = chatMessages.scrollHeight;
		});
	},

	// 发送消息成功回调
	send_message(data) {
		const that = globalState;
		const date = data.data;
		const item = that.session_messages.find((item) => item.id == date.message_id);
		if (!item) return;
		item.id = Number(date.id);
        that.unexpected_records = that.unexpected_records + 1;
	},

	// 已读消息回调
	read_message_done(data) {
		const that = globalState;
		const date = data.data;
		// console.log('已读消息消息', date);
		if (that.activeSession.id != date.session_id) return;
		if (date.record_id == 'all') {
			that.session_messages.forEach((item) => (item.status = 1));
		} else {
			that.session_messages.forEach((item) => {
				if (item.id == date.record_id) {
					item.status = 1;
				}
			});
		}
	},

	// 撤回消息成功回调
	recall_message(data) {
		const that = globalState;
		let date = data.data;
		// console.log('撤回消息', date);
		// record_id :  "3037"
		// session_id : "442"
		if (date.session_id == that.activeSession.id) {
			// 更新当前会话列表中的消息
			that.session_messages.forEach((item) => {
				if (item.id == date.record_id) {
					item.isrevoke = false;
					item.message_type = 12;
					item.message = item.name + ' 撤回了一条消息。';
				}
			});
		}
		// 更新左侧列表中的最新消息
		const updateList = (list) =>
			list.map((item) =>
				item.id == date.session_id
					? {
							...item,
							last_message: date.last_message || ''
					  }
					: item
			);
		if (that.activeSession.session_type == 0) {
			// 私聊：更新私聊列表
			that.session_list.private = updateList(that.session_list.private);
		} else {
			// 群聊：更新群聊列表
			that.session_list.group = updateList(that.session_list.group);
		}
		// 全部列表更新
		that.session_list.all = updateList(that.session_list.all);
	},

	// 目前已知：拉黑黑名单触发
	clear(data) {
		const that = globalState;
		// console.log('clear', data);
		if (data.msg) return this.$toast.show(data.msg);
		this.$toast.show('您已被拉黑，无法继续聊天！');
		that.isBlack = true;
	},

	// 我的寄售商品
	user_flow_product(data) {
		const that = globalState;
		const date = data.data;
		that.productParams.loading = false;
		that.productList = date.list || [];
		that.productParams.total = date.total_num;
	},

    user_sjz_product(data) {
		const that = globalState;
		const date = data.data;
		that.sjzRentalParams.loading = false;
		that.sjzRentalList = date.list || [];
		that.sjzRentalParams.total = date.total;
	},

	// 我的订单 - 订单列表
	order_list(data) {
		const that = globalState;
		const date = data.data;
		that.secondHandParams.loading = false;
		that.secondHandList = date.list || [];
		that.secondHandParams.total = date.total;
	},
    
	// 我的订单 - 三角洲列表
	rental_order_list(data) {
		const that = globalState;
		const date = data.data;
		that.deltaRentalParams.loading = false;
		that.deltaRentalList = date.list || [];
		that.deltaRentalParams.total = date.total;
	},

    // 我的订单 - 三角洲撞车列表
    collision_order_list(data) {
		const that = globalState;
		const date = data.data;
        console.log('三角洲撞车列表', date)
		that.deltaCrashParams.loading = false;
		that.deltaCrashList = date.list || [];
		that.deltaCrashParams.total = date.total;
	},

	// 我的订单 - 卡密列表
	carmi_order_list(data) {
		const that = globalState;
		const date = data.data;
		that.carmiParams.loading = false;
		that.carmiList = date.list || [];
		that.carmiParams.total = date.total;
	},

	// 我的咨询 - 浏览记录
	consult_goods(data) {
		const that = globalState;
		const date = data.data;
		that.browseParams.loading = false;
		that.browse_list = date.list || [];
		that.browseParams.total = date.total;
	},

	// 我的收藏 - 收藏列表
	collect_list(data) {
		const that = globalState;
		const date = data.data;
		that.collectParams.loading = false;
		that.collect_list = date.list || [];
		that.collectParams.total = date.total;
	},

    // 获取三角洲租赁订单详情
    sjz_product_detail(data) {
		const that = globalState;
		const date = data.data;
        localStorage.removeItem('rental_product_sn');

        that.indexSocket.send({
            c: 'Message', // 控制器
            a: 'sendMessage', // 动作
            data: {
                message: this.buildProductInfo(date.info, 16),
                message_type: 16,
                session_id: that.activeSession.id || '',
                token: localStorage.getItem('kefu_tourists_token') || '',
                modulename: 'index', // 模块名
                message_id: this.generateMessageId() // 消息唯一ID
            }
        });

        // 构建本地消息插入聊天框
		this.buildRecord({ message: this.buildProductInfo(date.info, 16), message_type: 16 }, 'append', this.generateMessageId());
	},

    // 客服端创建的新私聊会话
    new_private_session(data) {
        console.log('new_private_session', data)
        const that = globalState;
		const date = data.data;

        this.$set(that.session_list, 'all', [date, ...that.session_list.all]);
        this.$set(that.session_list, 'private', [date, ...that.session_list.private]);
    },

	// ── 工具方法 ──────────────────────────────────────────────────────────
	/**
	 * 生成本地临时消息 ID（时间戳 + 随机数）
	 * 服务端确认后会返回真实 id 替换
	 * @returns {number}
	 */
	generateMessageId() {
		return Date.now() + 246 + Math.floor(Math.random() * 10000);
	},

    // 商品字段拼接
    buildProductInfo(item, message_type) {
        const productInfoParts = [`message_type=${message_type}`];
        for (const key in item) {
            if (!Object.hasOwn(item, key)) continue;
            
            const element = item[key];
            // console.log('element', key + ':' + ' ' + element)
            productInfoParts.push(`${key}=${element}`);
        }

        // console.log('productInfoParts', productInfoParts.join('#'));
        
        return productInfoParts.join('#');
    },

    // 商品字段解析
    getProductInfo(item) {
        // 将字符串按 `#` 分割成一个数组
        const pairs = item.message.split('#');
        
        // 使用 reduce 将数组转成对象
        const result = pairs.reduce((acc, pair) => {
            // 跳过空字符串
            if (!pair || pair.trim() === '') {
                return acc;
            }
            
            // 找到第一个等号的位置
            const equalIndex = pair.indexOf('=');
            
            // 如果没有等号，跳过
            if (equalIndex === -1) {
                console.warn('跳过无效字段:', pair);
                return acc;
            }
            
            // 正确分割键和值（值可能包含等号）
            const key = pair.substring(0, equalIndex).trim();
            const value = pair.substring(equalIndex + 1);
            
            acc[key] = value;
            return acc;
        }, {});
        
        return result;
    },

    // 处理图片 URL 第一个
    handleImageUrl(imgs) {
        if (!imgs) return '';
        return imgs.split(',')[0];
    },

    // 处理图片 URL 处理成数组
    handleImageList(imgs) {
        if (!imgs) return [];
        return imgs.split(',');
    },
};

// ─── 默认导出（组合对象，方便组件一次性引入）────────────────────────────────

export default {
	state: globalState,
	methods: globalMethods
};
